import { EIPRToothMap, IIPRDataItem } from "@/shared/types"
import { Input } from "@mui/material"
import classNames from "classnames"
import { FC } from "react"
import { IUpdateToothDataParams } from "."
import "./scss/StageItemValue.scss"
interface IProps {
  dataType:
    | "iprURToothDataMemo"
    | "iprULToothDataMemo"
    | "iprLRToothDataMemo"
    | "iprLLToothDataMemo"
  id: EIPRToothMap
  item: IIPRDataItem
  itemIndex: number
  updateToothData: (data: IUpdateToothDataParams) => void
}
const StageItemValue: FC<IProps> = ({
  dataType,
  id,
  item,
  itemIndex,
  updateToothData,
}) => {
  const max = 1
  const min = 0

  const handleChange = (value: string) => {
    console.log("handleChange", value)
    const newValue = value ? (Number.parseFloat(value) > 0 ? value : "") : ""
    if (!newValue) return
    updateToothData({
      dataType,
      id,
      itemIndex,
      value: { isActive: item.isActive ? 0 : 1, actualValue: "" },
    })
  }

  return (
    <div className="stage-item-value">
      <div
        className={classNames("ux-value hover", {
          "ux-value-disabled":
            !item.value || Number.parseFloat(item.value) === 0,
          "ux-value-active": item.isActive,
        })}
        onClick={() => handleChange(item.value)}
      >
        {item.value
          ? Number.parseFloat(item.value) === 0
            ? "-"
            : Number(item.value).toFixed(1)
          : "-"}
      </div>
      <div className="current-input-wrap">
        <Input
          value={item.actualValue}
          type="number"
          disableUnderline={true}
          onChange={(e: any) => {
            let value = e.target.value
            if (value > max) {
              value = max
            } else if (value < min) {
              value = min
            }
            const splitValue = value.split(".")
            if (splitValue.length > 1 && splitValue[1].length > 1) {
              return
            }

            updateToothData({
              dataType,
              id,
              itemIndex,
              value: {
                isActive: Number.parseFloat(item.value) > 0 ? 0 : item.isActive,
                actualValue: value,
              },
            })
          }}
        />
      </div>
    </div>
  )
}

export default StageItemValue
